import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { ProgrammeRecommendation } from '../types';
import { RecommendationCopyKeys, createRecommendationCopy } from '../copy';

import { updateProgrammeRecommendation } from '@api';
import { CurriculumQueryKeys } from '@services';

export const useUpdateProgrammeRecommendation = (
    recommendationId: number | undefined,
    onSuccessCallback?: () => void,
) => {
    const queryClient = useQueryClient();

    const { mutate: updateRecommendation, isPending: isUpdating } = useMutation(
        {
            mutationFn: (data: Partial<ProgrammeRecommendation>) =>
                updateProgrammeRecommendation(recommendationId, data),
            onSuccess: () => {
                enqueueSnackbar(
                    createRecommendationCopy(
                        RecommendationCopyKeys.UPDATE_SUCCESS,
                    ),
                    {
                        key: 'edit-recommendation-success',
                        testId: 'edit-recommendation-success',
                        variant: 'curriculumSnackbar',
                        severity: 'success',
                    },
                );

                queryClient.invalidateQueries({
                    queryKey: [CurriculumQueryKeys.PROGRAMME_RECOMMENDATIONS],
                });

                onSuccessCallback?.();
            },
            onError: (error: Error) => {
                enqueueSnackbar(error.message, {
                    title: createRecommendationCopy(
                        RecommendationCopyKeys.UPDATE_ERROR,
                    ),
                    key: 'edit-recommendation-error',
                    testId: 'edit-recommendation-error',
                    variant: 'curriculumSnackbar',
                    severity: 'error',
                });
            },
        },
    );

    return { updateRecommendation, isUpdating };
};
